import userApi from '~referral/api/user';

const ACTION_PREFIX = 'referral/user';

const ELIGIBILITY_DATA_INIT = `${ACTION_PREFIX}/ELIGIBILITY_DATA_INIT`;
const ELIGIBILITY_DATA_DONE = `${ACTION_PREFIX}/ELIGIBILITY_DATA_DONE`;
const ELIGIBILITY_DATA_ERROR = `${ACTION_PREFIX}/ELIGIBILITY_DATA_ERROR`;

const UPDATE_REFERRAL_CALLBACK_STATUS = `${ACTION_PREFIX
}/UPDATE_REFERRAL_CALLBACK_STATUS`;

export function updateReferralCallbackStatus(callbackStatus) {
  return {
    type: UPDATE_REFERRAL_CALLBACK_STATUS,
    payload: callbackStatus,
  };
}

export function loadReferralEligibilityData() {
  return async (dispatch) => {
    dispatch({
      type: ELIGIBILITY_DATA_INIT,
    });
    try {
      const json = await userApi.loadEligibilityData();
      dispatch({
        type: ELIGIBILITY_DATA_DONE,
        payload: json,
      });
    } catch (error) {
      dispatch({
        type: ELIGIBILITY_DATA_ERROR,
        error,
      });
    }
  };
}

const initialState = {
  fullName: '',
  userID: '',
  referralCallbackStatus: '',
  couponPresent: false,
  inviteAndEarn: false,
  trialPeriod: true,
  phoneVerified: false,
  locale: '',
  isEligibilityDataLoading: true,
  eligibilityDataError: null,
  eligibilityDataReceived: false,
  rcbCount: 0,
  referralManager: null,
  hasVisitedReferPage: null,
  hasRcbInLastThreeMonths: null,
  hasRcbInLastOneMonth: null,
  isUgBannerActive: false,
  hasReferred: false,
};

export default function userReducer(
  state = initialState, action,
) {
  switch (action.type) {
    case ELIGIBILITY_DATA_INIT:
      return {
        ...state,
        isEligibilityDataLoading: true,
      };
    case ELIGIBILITY_DATA_ERROR:
      return {
        ...state,
        isEligibilityDataLoading: true,
        eligibilityDataError: action.error,
      };
    case ELIGIBILITY_DATA_DONE:
      return {
        ...state,
        isEligibilityDataLoading: false,
        fullName: action.payload.full_name,
        userID: action.payload.user_id,
        referralCallbackStatus: action.payload.callback_status,
        couponPresent: action.payload.coupon_present,
        inviteAndEarn: action.payload.invite_and_earn_enabled,
        trialPeriod: action.payload.trial_period,
        phoneVerified: action.payload.phone_verified,
        locale: action.payload.locale,
        rcbCount: action.payload.rcb_count,
        eligibilityDataReceived: true,
        referralManager: action.payload.referral_manager,
        hasVisitedReferPage: action.payload.has_visited_refer_page,
        hasRcbInLastThreeMonths: action.payload.has_rcb_in_last_three_months,
        hasRcbInLastOneMonth: action.payload.has_rcb_in_last_one_month,
        isUgBannerActive: action.payload.is_ug_banner_active,
        previousAppliedCoupon: action.payload.previous_applied_coupon,
        hasReferred: action.payload.has_referred,
      };
    case UPDATE_REFERRAL_CALLBACK_STATUS:
      return {
        ...state,
        referralCallbackStatus: action.payload,
      };
    default:
      return state;
  }
}
